export default "__VITE_ASSET__Cy$9QJIM__"